// Why Do We Need a Step Registry?
// Imagine tomorrow business adds:TAX_INFO screen.

// Without a registry:
// Screen definitions are scattered everywhere.

// With a registry:
// All possible screens are defined in one place.

import { SEND_MONEY_ROUTES } from "../../routes/sendMoneyRoutes";
import type { WorkflowStep } from "../types/workflowStep";

export const STEP_REGISTRY: Record<string, WorkflowStep> = {
  PHONE: {
    key: "PHONE",
    route: SEND_MONEY_ROUTES.PHONE,
    title: "Phone Number",
    editBehavior: "REFLOW",
  },

  PIN: {
    key: "PIN",
    route: SEND_MONEY_ROUTES.PIN,
    title: "PIN",
    editBehavior: "REFLOW",
  },

  COUNTRY: {
    key: "COUNTRY",
    route: SEND_MONEY_ROUTES.COUNTRY,
    title: "Destination Country",
    editBehavior: "REFLOW",
  },

  STATE: {
    key: "STATE",
    route: SEND_MONEY_ROUTES.STATE,
    title: "State",
    editBehavior: "REFLOW",
  },

  AMOUNT: {
    key: "AMOUNT",
    route: SEND_MONEY_ROUTES.AMOUNT,
    title: "Amount",
    editBehavior: "REFLOW",
  },

  HOW_THEY_RECEIVE: {
    key: "HOW_THEY_RECEIVE",
    route: SEND_MONEY_ROUTES.HOW_THEY_RECEIVE,
    title: "How They Receive",
    editBehavior: "REFLOW",
  },

  REVIEW_AND_EDIT: {
    key: "REVIEW_AND_EDIT",
    route: SEND_MONEY_ROUTES.REVIEW_AND_EDIT,
    title: "Review and Edit",
    editBehavior: "REFLOW",
  },

  SENDER_INFO: {
    key: "SENDER_INFO",
    route: SEND_MONEY_ROUTES.SENDER_INFO,
    title: "Sender Information",
    editBehavior: "RETURN_TO_REVIEW",
  },

  SENDER_ADDRESS: {
    key: "SENDER_ADDRESS",
    route: SEND_MONEY_ROUTES.SENDER_ADDRESS,
    title: "Sender Address",
    editBehavior: "RETURN_TO_REVIEW",
  },

  SENDER_DOB: {
    key: "SENDER_DOB",
    route: SEND_MONEY_ROUTES.SENDER_DOB,
    title: "Sender DOB",
    editBehavior: "RETURN_TO_REVIEW",
  },

  SENDER_ID1: {
    key: "SENDER_ID1",
    route: SEND_MONEY_ROUTES.SENDER_ID1,
    title: "Sender ID",
    editBehavior: "RETURN_TO_REVIEW",
  },

  SENDER_ID2: {
    key: "SENDER_ID2",
    route: SEND_MONEY_ROUTES.SENDER_ID2,
    title: "Secondary Sender ID",
    editBehavior: "RETURN_TO_REVIEW",
  },

  RECEIVER_INFO: {
    key: "RECEIVER_INFO",
    route: SEND_MONEY_ROUTES.RECEIVER_INFO,
    title: "Receiver Information",
    editBehavior: "RETURN_TO_REVIEW",
  },

  ADDITIONAL_INFO: {
    key: "ADDITIONAL_INFO",
    route: SEND_MONEY_ROUTES.ADDITIONAL_INFO,
    title: "Additional Information",
    editBehavior: "RETURN_TO_REVIEW",
  },

  FRAUD_PREVENTION: {
    key: "FRAUD_PREVENTION",
    route: SEND_MONEY_ROUTES.FRAUD_PREVENTION,
    title: "Fraud Prevention",
    editBehavior: "RETURN_TO_REVIEW",
  },

  FINAL_REVIEW: {
    key: "FINAL_REVIEW",
    route: SEND_MONEY_ROUTES.FINAL_REVIEW,
    title: "Final Review",
    editBehavior: "REFLOW",
  },

  HEAD_TO_CASHIER: {
    key: "HEAD_TO_CASHIER",
    route: SEND_MONEY_ROUTES.HEAD_TO_CASHIER,
    title: "Head to Cashier",
    editBehavior: "REFLOW",
  },
};


//Record<string, WorkflowStep>
// Example:
// STEP_REGISTRY["PHONE"]
// returns
// {
//   key: "PHONE",
//   route: SEND_MONEY_ROUTES.PHONE,
//   title: "Phone Number",
//   editBehavior: "REFLOW",
// }